<div class="flex_container">
    
    <div class="flex_actions">
        <organization-select    #orgManager
        class           =   "fullWidth"
        autoSelectFirst =   "true"
        > </organization-select>                        

        <site-select            #siteManager
        [org]           =   "orgManager?.currentValue"
        autoSelectFirst =   "true"
        class           =   "fullWidth"
        (change)        =   "setSite($event)"
        > </site-select>
        
        <service-select         #serviceManager
        [site]          =   "siteManager?.currentValue"
        autoSelectFirst =   "true"
        class           =   "fullWidth"
        (change)        =   "setService($event)"
        > </service-select>

        <ng-container *ngIf="service">

            <div class="border date-container">
        
                <div>
                    
                    <div class="date">
                    
                        <mat-form-field class="def-select single-element-select" appearance="outline" floatLabel="always">
                            <mat-label translate> tables.booking.chooseDate</mat-label>
                            <input  matInput 
                                    [matDatepicker] = "picker" 
                                    [(ngModel)] = "chooseDate" 
                                    (dateInput)="dateChange()" 
                                    (dateChange)="dateChange()" 
                                    [min] = "minDate"
                                    readonly>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>    
            
                    </div>

                    <div class="actions-container">
                        <div class="fast_back">
                            <button mat-icon-button>
                                <mat-icon (click) = "click('fast_back')"  matTooltip = "Giorno precedente libero">fast_rewind</mat-icon>
                            </button>
                        </div>
                
                        <div class="back">
                            <button mat-icon-button>
                                <mat-icon (click) = "click('back')" matTooltip = "Giorno precedente">keyboard_arrow_left</mat-icon>
                            </button>
                        </div>
                
                        <div class="next">
                            <button mat-icon-button>
                                <mat-icon (click) = "click('next')" matTooltip="Giorno successivo">keyboard_arrow_right</mat-icon>
                            </button>
                        </div>
                
                        <div class="fast_next">
                            <button mat-icon-button>
                                <mat-icon (click) = "click('fast_next')" matTooltip="Prossimo giorno libero">fast_forward</mat-icon>
                            </button>
                        </div>
                    </div>
                    
                    
                </div>
            </div>
            <br>
        </ng-container>
        <legenda [legends]="booking_legend"></legenda>
    </div>

    <div class="flex_slots">

        <help-alert 
                text        = "help.page.booking.field"
                action      = "help.page.booking.action" 
                info        = "help.info"
                description = "help.page.booking.description">
        </help-alert>

        <br>
        <br>

        <custom-table #bookingTable
            table_id            =   "bookingTable"
            no_title_value      =   "tables.booking.no_title_value"
            title_single        =   "tables.booking.title_single"
            title_multiple      =   "tables.booking.title"
            filter_title        =   "tables.booking.filter_title"
            search_title        =   "tables.booking.search_title"
            [columns]           =   "bookingServiceColums"
            [values]            =   "values"
            [parent]            =   "this"
            [create]            =   "false"
            [update]            =   "false"
            [delete]            =   "false"
            [icon_buttons]      =   "icon_buttons"
            [header_buttons]    =   "header_buttons"
            [pdf_buttons]       =   "pdf_buttons"
            reloadable          =   "true"
            (refresh)           =   "init()"
            [row_styles]        =   "booking_rows_style"
        ></custom-table>

    </div>
</div>



